export class GetMerchantInformation {
  static readonly type = '[Merchant] Get Merchant Information';
}
